var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullYellowSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "0 0 101 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5404 51.0002C77.5404 65.9569 65.4359 78.0614 50.4792 78.0614C35.5225 78.0614 23.418 65.9569 23.418 51.0002C23.418 36.0435 35.5225 23.939 50.4792 23.939C65.4359 23.939 77.5404 36.0435 77.5404 51.0002Z",
    fill: "#FFC556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7969 18.7347L50.2203 0L54.6438 18.7347H45.7969Z",
    fill: "#FFC556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0708 22.3777L32.7852 3.12256L43.7137 19.3669L35.0708 22.3777Z",
    fill: "#FFC556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1231 29.1427L17.6934 11.9692L32.7852 23.4644L26.1231 29.1427Z",
    fill: "#FFC556"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.076 39.0306L6.24414 25.5L24.4584 31.1259L20.076 39.0306Z",
    fill: "#FFC556"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7202 49.9592L0 42.2357L19.2551 41.1123L17.7202 49.9592Z",
    fill: "#FFC556"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2551 60.8876L0 59.8302L17.7202 52.561L19.2551 60.8876Z",
    fill: "#FFC556"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4584 71.022L6.24414 76.5L20.0076 63.4897L24.4584 71.022Z",
    fill: "#FFC556"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7852 78.6045L17.6934 90.0304L26.1231 72.8569L32.7852 78.6045Z",
    fill: "#FFC556"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7137 83.1406L32.7852 98.8778L35.0708 80.1431L43.7137 83.1406Z",
    fill: "#FFC556"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6438 83.2651L50.2203 102L45.7969 83.2651H54.6438Z",
    fill: "#FFC556"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4755 80.1431L67.6523 98.8778L57.2441 83.1406L65.4755 80.1431Z",
    fill: "#FFC556"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5442 72.8569L83.2646 90.0304L67.6523 78.6045L74.5442 72.8569Z",
    fill: "#FFC556"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5585 63.4897L94.7152 76.5L75.9805 71.0904L80.5585 63.4897Z",
    fill: "#FFC556"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7185 52.561L100.439 59.8302L81.1836 60.8876L82.7185 52.561Z",
    fill: "#FFC556"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1836 41.1123L100.439 42.2357L82.7824 49.9592L81.1836 41.1123Z",
    fill: "#FFC556"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9805 31.1673L94.7152 25.5L80.5585 39.0306L75.9805 31.1673Z",
    fill: "#FFC556"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6523 23.4644L83.2646 11.9692L74.5442 29.1427L67.6523 23.4644Z",
    fill: "#FFC556"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2441 19.3669L67.6523 3.12256L65.4755 22.3777L57.2441 19.3669Z",
    fill: "#FFC556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullYellowSun);
export default __webpack_public_path__ + "static/media/FullYellowSun.e5752da98cfe680062253ff11385e2ae.svg";
export { ForwardRef as ReactComponent };